/**
 * Static copy for the Policy Details form.
 */
export const POLICY_DETAILS_CONFIG = {
  activation: {
    label: 'Warranties require activation',
    description: 'Customers will have to activate their warranty the first time they visit the customer portal.',
  },
  allowMarkup: {
    label: 'Allow distributor markup at checkout',
    description: 'Internal sellers can add a markup to the warranty price during checkout.',
  },
  checkClaimEligibility: {
    label: 'Check claim eligibility before approval',
    description:
      'Each repair job is checked against the loss date, waiting period, coverage, asset and limits, and can only be approved once it passes.',
    detailsLabel: 'Claim Eligibility Check',
    on: 'On',
    off: 'Off',
  },
} as const;
